import { snapshot, subscribe } from 'valtio'

import { editableArea } from './editableArea'

type Subscriber = (area: workwave.DeepReadonly<uui.domain.ui.map.EditableArea>) => void

export function subscribeToEditableArea(subscriber: Subscriber, sync: boolean = true) {
  return subscribe(editableArea, () => subscriber(snapshot(editableArea.area)), sync)
}
